<template>
    <div id="exportable-content">
        <Hero title="GDPR Data Protection Agreement (DPA)" colour-index="4"
            subtitle="Date of last revision: March 19, 2026" />

        <main class="_article pt-8 pb-8">
            <article class="prose p-3 max-w-7xl m-auto">
                <!-- <ContentRendererMarkdown class="px-3 sm:px-28" :value="data[0]"
                ><template #not-found><div></div></template>
    </ContentRendererMarkdown> -->

                <ContentRenderer v-if="page" class="content-doc px-3 sm:px-28" :value="page" />
            </article>
        </main>
    </div>
</template>

<script setup lang="ts">
import { setTitle } from '~~/services/common';

const route = useRoute();

const { data: page } = await useAsyncData(route.path, () =>
    queryCollection('content').path(route.path).first()
);

setTitle(
    'GDPR Data Protection Agreement (DPA)',
    'Unified.to Data Protection Agreement describing how we process personal data on behalf of our customers under GDPR.'
);
</script>